import { proxy } from 'valtio';
import { FuiTabs2 } from '../heineken_template/components/FuiTabs2';
export const gorich55688_store = proxy({
    marketStatus: '',
    screenerTabs: new FuiTabs2(['強勢整理股', '籌碼優勢股']),
});
